<template>
  <button class="custom-button">
    <slot name="btnContent"></slot>
  </button>
</template>

<script>
import './button.scss';

export default {
  name: 'ButtonComponent',
  components: {},
  data() {
    return {

    }
  },
}
</script>

